const qlBtn = document.getElementById('qlBtn');

function toggleQuickLinks({target}){
	const expanded = target.getAttribute('aria-expanded') === 'true' || false;
	const ql = document.getElementById('quicklinks');
	ql.classList.toggle('open');
	qlBtn.setAttribute('aria-expanded', !expanded);
	
}

qlBtn.addEventListener('click', toggleQuickLinks, false);


export default {
	toggleQuickLinks: toggleQuickLinks
};